import React from "react";
import MessagesAPI from "../../components/MessagesAPI";
import ProtectedRoute from "../../components/ProtectedRoute";

const MessagesApiPage = () => {
  return (
    <ProtectedRoute requiredRoles={["super", "admin"]} fallbackPath="/tickets">
      <MessagesAPI />
    </ProtectedRoute>
  );
};

export default MessagesApiPage;
